import React from 'react';
import { ATTRIBUTE_OPTIONS } from './utils';
import { useSessionContext } from './SessionContext';
import AboutText from './AboutText';
import Legend from './Legend';

function HexagonOpacityControl() {
  const { hexagonOpacity, setHexagonOpacity } = useSessionContext();
  return (
    <div className="hexagon-opacity-control">
      <span style={{ fontSize: '16px', fontWeight: 'bold', margin: '4px' }}>Hexagon Opacity</span>
      <input
        className="slider opacity-slider"
        style={{ margin: '10px 0' }}
        type="range"
        min={1}
        max={100}
        value={hexagonOpacity}
        onChange={(event) => setHexagonOpacity(parseInt(event.target.value, 10))}
      />
    </div>
  );
}

function AttributePicker() {
  const { selectedAttribute, setSelectedAttribute } = useSessionContext();
  return (
    <div className="attribute-dropdown">
      <select
        value={selectedAttribute}
        onChange={(e) => setSelectedAttribute(e.target.value)}
      >
        {Object.entries(ATTRIBUTE_OPTIONS).map(([value, config]) => (
          <option key={value} value={value}>{config.label}</option>
        ))}
      </select>
    </div>
  );
}

export default function RightPanel() {
  return (
    <div className="frosted right-panel">
      <div className="no-mobile">
        <Legend />
      </div>
      <AttributePicker />
      <hr className="divider" />
      <HexagonOpacityControl />
      <hr className="divider about-text-divider" />
      <AboutText />
    </div>
  );
}
